<script>
import { SupabaseClient } from '@supabase/supabase-js';

  import { supabase } from './supabaseClient'

let newUser
let submit = false

async function sendData() {
	const { data, error } =  await supabase
	.from('table_firstuser')
	.insert([
		{'useremail': newUser }
	])
	if (error) throw new Error(error.message)
}
</script>


<style>
	html { background-color : #b3e7ff !important;}
	.bg-c { background-color: #b3e7ff !important;}
body { font-family: 'Poppins', sans-serif !important; background-color:#b3e7ff !important; ;}
    .mrv-front { max-width: 1230px; margin : auto;  font-family: 'Poppins', sans-serif !important; }
    .mrv-front h1 { 
        font-size : 3em; font-weight: 700;
        line-height: 50px;
        margin-bottom : 20px;
        }
    .mrv-front p {
            font-size: 1.5em;
    }
    .ssup { margin-top : 20px;}

.is-m { font-size : 1.7em;}
.height40 { height : 90px;}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	.duff { background-color: #f6f6f6;}
</style>

<section class="section is-small">
	<div class="mrv-front">
	
	<a href="https://marvo.me"><img src="marvo_logo.png" alt='Marvo' srcset="marvo_logo@2x.png 2x"></a>
</div>

</section>
<section class="section is-medium">

    <div class="mrv-front">
       
            <div class="columns">
                <div class="column">
                    <h1 class="title is-size-3-mobile	">Go finish what you started, one project at a time</h1>
                    <p class=" is-m is-size-5-mobile	">Marvo is personal project management app for people whow generates idea everyday to stay organized.</p>
                	<div class="ssup is-mobile">
						<h3 class="title is-5">Be the first to know when it's 🚀</h3>
						<form on:submit|preventDefault={() => submit = true}>
							<div class="field">
								<div class="control is-expanded">
									<input class="input is-medium mb-4" type="email" placeholder="Your email" bind:value={newUser} required>
									<button class="button is-medium is-info" disabled={submit} type="submit" value="Submit" on:click={() => submit = false}>Let me know</button>
								</div>

							</div>
						
						</form>
								{#if submit}
									{#await sendData()}
										<p class="is-size-5-mobile">Sending data...</p>
									{:then data}
										<p class="mt-3 is-size-6-desktop is-size-5-mobile">Hello. Thank you {newUser}, we'll be in touch.</p>
									{:catch error}
										<p>Something went wrong while sending the data:</p>
									
									{/await}
									{/if}
								
							
                	</div>
				</div>
                <div class="column">
                    <img src="marvo_people.png" alt="Marvo">
                </div>
            </div>
    </div>
</section>


<section class="hero is-small">
	<div class="mrv-front hero-body">
		<div class="columns mb-6">
			<div class="column">
				<h2 class="title is-3">your ideas, projects, logs and task list in one place</h2>
				<p>Marvo dashboard shows what are you working on in one place, as a go-to place of a reminder of your own project. </p>
			</div>
			<div class="column is-two-thirds">
			
				<img src="mrv-dashboard.png" alt="Marvo dashboard">
			</div>
		</div>
		<div class="height40"></div>

		<div class="columns mb-6">
			<div class="column is-two-thirds">
			
				<img src="mrv-newproject.png" alt="Marvo Project">
			</div>
			<div class="column">
				<h3 class="title is-3">Start your project right! Set outcomes and timeline.</h3>
				<p>A follow-through is important, so we provide your simple template goals for your personal project </p>
			

			</div>
		</div>

		<div class="height40"></div>

		<div class="columns mb-6">
			<div class="column">
				<h2 class="title is-3">Write and break down your idea before you turn into project</h2>
				<p>Sometimes we generate ideas while we're on project and we need to jot it down before you forget. </p>
				<p>You can always write idea before you turn it into a project</p>
			</div>
			<div class="column is-two-thirds">
			
				<img src="mrv-idea.png" alt="Marvo Idea">
			</div>
			<div class="height40"></div>


	</div>
       
</section>







<section class="hero is-small duff has-text-centered">

	<div class="hero-body mrv-front">

	<p class="content is-6 is-size-6-desktop	is-size-6-mobile	">&copy; Marvo 2021. say hello : rifie@marvo.me</p>
</div>

</section>






